export var ANGULAR_ROUTING_OP = 'ui.angular.routing';
export var ANGULAR_INIT_OP = 'ui.angular.init';
export var ANGULAR_OP = 'ui.angular';
